import { BookletDate } from "@/@types";
import { BookletDateResponse } from "../../booklets/models/BookletDateResponse";

export function mapBookletDate(response: BookletDateResponse): BookletDate {
    const mappedResponse: BookletDate = {};

    for (const month in response) {
        if (response.hasOwnProperty(month)) {
            mappedResponse[month] = response[month].map(booklet => ({
                title: booklet.title,
                order: booklet.order,
                slug: booklet.slug,
                createdAt: booklet.created_at,
                category_slug: booklet.category_slug
            }));
        }
    }

    return mappedResponse;
}